import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { ONBOARDING_STEPS_COMPLETED } from "../user/onboardingStepsCompleted";
import { SUBSCRIPTION_OFFERS } from "./getSubscriptionOffers";

export const SUBSCRIPTION_OFFER_CREATE = gql(`
    mutation subscriptionOfferCreate(
      $organizationId: ID!,
      $appSlug: String!,
      $email: String!,
      $message: String,
      $name: String,
      $expiresAt: Time,
      $payment: PaymentConfigurationInput
    ) {
      subscriptionOfferCreate(organizationId: $organizationId, input:  {
         appSlug: $appSlug,
         email: $email,
         message: $message,
         name: $name,
         expiresAt: $expiresAt,
         payment:  $payment
      }) {
        ... on SubscriptionOffer {
          __typename
          id
          email
          status
          name
          createdAt
          payment {
            __typename
            monthlyPriceUSD
            trialDays
          }
          app {
            __typename
            id
            displayName
            pictureUrl
          }
        }
        ... on InvalidEmail {
          __typename
          email
        }
        ... on OfferInvalidExpiresAt {
          __typename
          expiresAt
        }
        ... on OfferInvalidMonthlyPriceUSD {
          __typename
          monthlyPriceUSD
        }
        ... on OfferInvalidTrialDays {
          __typename
          trialDays
        }
      }
    }
  `);

export function useSubscriptionOfferCreate(organizationSlug: string) {
  return useMutation(SUBSCRIPTION_OFFER_CREATE, {
    update: (cache, data) => {
      const offer =
        data.data?.subscriptionOfferCreate.__typename === "SubscriptionOffer" &&
        data.data?.subscriptionOfferCreate;
      if (!offer) return cache;

      cache.updateQuery(
        { query: SUBSCRIPTION_OFFERS, variables: { organizationSlug } },
        (cachedOffersQuery) => {
          if (!cachedOffersQuery) return null;

          const cachedOffers =
            cachedOffersQuery.organization?.__typename === "Organization"
              ? cachedOffersQuery.organization.outboundSubscriptionOffers
              : [];

          return {
            ...cachedOffersQuery,
            organization: {
              ...cachedOffersQuery?.organization,
              outboundSubscriptionOffers: [offer, ...cachedOffers]
            }
          };
        }
      );

      return cache;
    },
    refetchQueries: [ONBOARDING_STEPS_COMPLETED]
  });
}
